// extracted by mini-css-extract-plugin
export var center = "style-module--center--z6fRB";